import { Component } from '@angular/core';
import { Store } from '@ngrx/store';

import { LoadAccounts } from '@account-users/account/state/accounts/accounts.actions';
import { LoadPermissions } from '@account-users/user/state/permissions/permissions.actions';

import { State } from '../../reducers';

@Component({
  selector: 'app-email',
  template: '<router-outlet></router-outlet>',
})
export class EmailComponent {
  constructor(private readonly store: Store<State>) {
    this.store.dispatch(new LoadAccounts({ loadAll: true }));
    this.store.dispatch(new LoadPermissions());
  }
}
